export enum STATE_STORE_KEYS {
	UserList = 'UserList',
	CreatUser = 'CreateUser',
	UpdateUser = 'UpdateUser',
	AssignUsers = 'AssignUsers',
	CurrentUser = 'CurrentUser',
	ValidateUser = 'ValidateUser',
	CreationProject = 'CreationProject',
	EMailVerification = 'EmailVerification',
	UserChangePassword = 'UserChangePassword',

	Projects = 'Project',
	BlockProject = 'BlockProject',
	UpdateProject = 'UpdateProject',
	DeleteProject = 'DeleteProject',
	ArchiveProject = 'ArchiveProject',

	ProjectCertificationSettings = 'ProjectCertificationSettings',
	ProjectCertificationSettingsUpdate = 'ProjectCertificationSettingsUpdate',

	DeleteTemplate = 'DeleteTemplate',
	CreationTemplate = 'CreationTemplate',
	GetTemplate = 'GetTemplate',

	AddTimeframe = 'AddTimeframe',
	ActivateTimeframe = 'ActivateTimeframe',

	UpdateSubPhase = 'UpdateSubPhase',
	DocumentChecking = 'DocumentChecking',
	ReviewChecklists = 'ReviewChecklists',
	BillingAddress = 'BillingAddress',

	ChatList = 'ChatList',
	ChatMessages = 'ChatMessages',
	ChatMessageAdd = 'ChatMessageAdd',
	ChatMessageRead = 'ChatMessageRead',
	ChatMessageCount = 'ChatMessageCount',
	ChatNoteList = 'ChatNoteList',
	ChatNoteAdd = 'ChatNoteAdd',
	ChatNoteDelete = 'ChatNoteDelete',
	ChatNoteSend = 'ChatNoteSend',
	ChatNoteUpdate = 'ChatNoteUpdate',
	ChatMessageEmailNotify = 'ChatMessageEmailNotify',
	ChatAllMessageCount = 'ChatAllMessageCount',
	ChatMessageDelete = 'ChatMessageDelete',
	ChatMessageReadAll = 'ChatMessageReadAll',

	InvoiceInteractive = 'InvoiceInteractive',
	GetClientsList = 'GetClientsList',

	Client = 'Client',
	ClientProjects = 'ClientProjects',
	MemberInteractive = 'MemberInteractive',
	MemberProjects = 'MemberProjects',
	DeleteUser = 'DeleteUser',

	CurrentChecklist = 'CurrentChecklist',
	AddChecklistItem = 'AddChecklistItem',
	DeleteChecklistItem = 'DeleteChecklistItem',
	UpdateChecklistItem = 'UpdateChecklistItem',
	GetChecklistItem = 'GetChecklistItem',
	PostAnswers = 'PostAnswers',
	SetQuestionStatus = 'SetQuestionStatus',
	AddQuestionComment = 'AddQuestionComment',
	SetPreDefinedComment = 'SetPreDefinedComment',
	InspectChecklistItem = 'InspectChecklistItem',
	ChecklistAvailableVersions = 'ChecklistAvailableVersions',
	UpdateChecklistVersion = 'UpdateChecklistVersion',

	ProjectAuthor = 'ProjectAuthor',
	ProjectManagers = 'ProjectManagers',

	getQuestions = 'getQuestions',

	TeamApiInteractive = 'TeamApiInteractive',
	TeamProjects = 'TeamProjects',

	ProjectIdsList = 'ProjectIdsList',
	ProjectAll = 'ProjectAll',
	ProjectCount = 'ProjectCount',

	ActivityLogList = 'ActivityLogList',
	ActivityLogUserList = 'ActivityLogUserList',
	ActivityLogAllList = 'ActivityLogAllList',
	ActivityLogUserAllList = 'ActivityLogUserAllList',

	EmployeesInteractive = 'EmployeesInteractive',

	ChecklistInteractive = 'ChecklistInteractive',
	ChecklistVersions = 'ChecklistVersions',

	ProductList = 'ProductList',
	ProductCreate = 'ProductCreate',
	ProductDBUpdate = 'ProductDBUpdate',
	ProductAttributeList = 'ProductAttributeList',
	ProductTypeList = 'ProductTypeList',
	AdditionalEquipment = 'AdditionalEquipment',
	ManufacturerList = 'ManufacturerList',
	ProductFind = 'ProductFind',
	ProductDelete = 'ProductDelete',
	DbProductDelete = 'DbProductDelete',
	ProductFilters = 'ProductFilters',
	ProductExport = 'ProductExport',
	ProductExportAll = 'ProductExportAll',
	DBProductList = 'DBProductList',
	ProductUpdate = 'ProductUpdate',
	ProductImport = 'ProductImport',

	CertificateList = 'CertificateList',
	CertificateMonitoring = 'CertificateMonitoring',
	CertificateListByProject = 'CertificateListByProject',
	CertificateDeleteById = 'DeleteCertificateById',
	CertificateGenerateById = 'CertificateGenerateById',
	CertificateDownload = 'CertificateDownload',
	CertificateNotifyAll = 'CertificateNotifyAll',
	CertificateUpload = 'CertificateUpload',
	CertificateMonitoringUpdate = 'CertificateMonitoringUpdate',

	Offers = 'Offers',
	GenerateOffer = 'GenerateOffer',
	DeleteOffer = 'DeleteOffer',
	DownloadOffer = 'DownloadOffer',
	UploadOffer = 'UploadOffer',
	GenerateOfferConfirmation = 'GenerateOfferConfirmation',

	EmployeeById = 'EmployeeById',
	EmployeeProjects = 'EmployeeProjects',
	EmployeeLis = 'EmployeeLis',
	EmployeeProjectsReassign = 'EmployeeProjectsReassign',
	EmployeeUserUpdate = 'EmployeeUserUpdate',

	Services = 'Services',

	ProjectsIds = 'ProjectsIds',

	EForm = 'EForm',

	ControllerList = 'ControllerList',
	ControllerTypeList = 'ControllerTypeList',
	ControllerFind = 'ControllerFind',
	ControllerDelete = 'ControllerDelete',
	ControllerUpdate = 'ControllerUpdate',
	ControllerCreate = 'ControllerCreate',
	ControllerExport = 'ControllerExport',
	ControllerImport = 'ControllerImport',
	ControllerExportAll = 'ControllerExportAll',

	ReportsInteractive = 'ReportsInteractive',
	ReportsDownload = 'ReportsDownload',
	ReportsDownloadTextmarks = 'ReportsDownloadTextmarks',

	ProtectorList = 'ProtectorList',
	ProtectorFind = 'ProtectorFind',
	ProtectorDelete = 'ProtectorDelete',
	ProtectorTypeList = 'ProtectorTypeList',
	ProtectorCompanyList = 'ProtectorCompanyList',
	ProtectorUpdate = 'ProtectorUpdate',
	ProtectorCreate = 'ProtectorCreate',
	ProtectorExport = 'ProtectorExport',
	ProtectorImport = 'ProtectorImport',
	ProtectorExportAll = 'ProtectorExportAll',

	NotificationList = 'NotificationList',
	NotificationRead = 'NotificationRead',
	NotificationReadAll = 'NotificationReadAll',

	CalculationResults = 'CalculationResults',
	Calculate = 'Calculate',

	OtherDocuments = 'OtherDocuments',
	UploadOtherDocument = 'UploadOtherDocument',

	EmailReminders = 'EmailReminders',
	EmailRemindersHistory = 'EmailRemindersHistory'
}
